import * as React from "react";
import { isEmpty } from "lodash-es";
import { EventContact } from "api/events/event.types";
import { AvatarInformations } from "components/EventInvitation/CardItem/AvatarInformations";
import { Card } from "src/components/common/Card";

interface Props {
  title: string;
  speakers: EventContact[];
}

export const CardSpeakers: React.FunctionComponent<Props> = ({ title, speakers }) => (
  <>
    {!isEmpty(speakers) ? (
      <Card title={title} className="card-bordered">
        <ul className="list-unstyled">
          <AvatarInformations contacts={speakers} />
        </ul>
      </Card>
    ) : null}
  </>
);
